import Link from 'next/link';

import FFHModal from '@components/modal';
import Button from '@components/atoms/button';
import Icon from '@components/atoms/icon';
import { BodyRegular, H3 } from '@components/atoms/typography';
import { AnalyticsEvents, captureAnalyticsEvent } from '@lib/analytics/events';

const JOIN_HREF = '/join';

// FFH-2372: analytics placement for the padlock upgrade modal CTA.
const UPGRADE_MODAL_PLACEMENT = 'upgrade_modal';

type UpgradeModalProps = {
  isOpen: boolean;
  /**
   * Feature name as it reads mid-sentence, e.g. "predicted points" or
   * "chip strategy".
   */
  feature: string;
  onClose: () => void;
};

/**
 * Conversion prompt shown when a non-paying member clicks a padlocked Pick
 * feature: names the feature, explains it is members-only, and links through
 * to the join page.
 */
export const UpgradeModal = ({
  isOpen,
  feature,
  onClose
}: UpgradeModalProps) => (
  <FFHModal
    open={isOpen}
    handleClose={onClose}
    title="Members-only feature"
    childrenClassName="w-[90vw] max-w-md"
  >
    <div
      className="flex flex-col items-center gap-4 px-6 py-10 text-center"
      data-cy="upgrade-modal"
    >
      <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 text-primary-600">
        <Icon name="Lock" fontSize="24px" />
      </span>
      <H3>Unlock {feature}</H3>
      <BodyRegular textColor="text-neutral-600">
        This is a members-only feature. Upgrade your account to unlock {feature}
        , plus every other premium tool on the Hub.
      </BodyRegular>
      <Link
        href={JOIN_HREF}
        className="w-full"
        data-cy="upgrade-modal-cta"
        onClick={() => {
          // FFH-2372: a generic /join CTA points at no specific plan.
          captureAnalyticsEvent(AnalyticsEvents.upgradeCtaClicked, {
            placement: UPGRADE_MODAL_PLACEMENT,
            intended_tier: null
          });
        }}
      >
        <Button variant="primary" className="w-full">
          Upgrade now
        </Button>
      </Link>
    </div>
  </FFHModal>
);

export default UpgradeModal;
